import { render } from "./IConButton.vue?vue&type=template&id=e059715a&ts=true"
import script from "./IConButton.vue?vue&type=script&lang=ts"
export * from "./IConButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__